module.exports = __webpack_public_path__ + "static/BentonSansExtraComp-Black-643c3800d5b23828acfc100f30bb04db.woff";